import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import simplebar from "simplebar-vue";
import VueTour from 'vue-tour'
import vco from "v-click-outside"
import * as VueGoogleMaps from "vue2-google-maps";
import i18n from './i18n'

import router from './router'
import store from '@/state/store'

import VueApexCharts from 'vue-apexcharts'
import VueStringFilter from 'vue-string-filter'
import Lightbox from 'vue-easy-lightbox'

Vue.config.productionTip = false

Vue.use(vco)

// As a plugin
import VueMask from 'v-mask'
import VueQuillEditor from 'vue-quill-editor'
import VueDraggable from "vue-draggable";

// Import Quill CSS files
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueDraggable);
Vue.use(VueQuillEditor)
Vue.use(VueMask);

import VueSlideBar from 'vue-slide-bar'

Vue.component('VueSlideBar', VueSlideBar)

import { initFirebaseBackend } from './authUtils';

import { configureFakeBackend } from './helpers/fake-backend';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
  configureFakeBackend();
}

Vue.component('apexchart', VueApexCharts)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(require('vue-chartist'))
Vue.component('simplebar', simplebar)
Vue.use(VueStringFilter)
Vue.use(VueTour)
Vue.use(Lightbox)

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
    libraries: "places"
  },
  installComponents: true
});

import "@/assets/scss/app.scss";

// 處理需要引用的元件
import Apis from './library/Apis'
import Common from './library/Common'

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  data: {
    apis: false,
    common: false,
    mediaUri: process.env.VUE_APP_MEDA_URL,
    uploadUri: process.env.VUE_APP_UPLD_URL,
    pluginUri: process.env.VUE_APP_PLUGIN_RUL,
    login: false
  },
  async created () {
    this.common = await new Common(this)
    this.apis = await new Apis(this)
    
    // 檢查登入狀態
    const loginCookie = this.common.getCookie("login")
    const token = this.common.getCookie("api-token")
    
    // 如果有 token，驗證其有效性
    if (token && loginCookie) {
      // 驗證 Token 是否有效
      this.apis.getMe((response) => {
        if (response.body.success) {
          this.login = true
          // 更新用戶資訊
          const userInfo = response.body.data
          this.common.setCookie("user", JSON.stringify(userInfo))
          console.log('Token 驗證成功，用戶已登入')
        } else {
          // Token 無效，清除登入狀態
          this.clearLoginState()
          if (this.$router.currentRoute.path !== '/login') {
            this.$router.push("/login")
          }
        }
      }, (error) => {
        // Token 無效或過期，清除登入狀態
        console.log('Token 驗證失敗，清除登入狀態')
        this.clearLoginState()
        if (this.$router.currentRoute.path !== '/login') {
          this.$router.push("/login")
        }
      })
    } else {
      // 沒有 token 或登入 cookie，清除登入狀態
      this.login = false
      this.clearLoginState()
      // 如果未登入且不在登入頁，跳轉到登入頁
      if (this.$router.currentRoute.path !== '/login') {
        this.$router.push("/login")
      }
    }
  },
  methods: {
    clearLoginState () {
      this.login = false
      this.common.setCookie("api-token", "")
      this.common.setCookie("user", "")
      this.common.setCookie("login", "")
    }
  }
}).$mount('#app')
